import Transform from '@ember-data/serializer/transform';
export default class Enum extends Transform {
  deserialize(serialized, {
    enumClass
  }) {
    return enumClass.deserialize(serialized);
  }
  serialize(deserialized, {
    enumClass
  }) {
    return enumClass.serialize(deserialized);
  }
}